/** 医療機器情報（バックエンド JSONB と一致） */

export const OXYGEN_OPTIONS = ['HOT', 'CPAP', 'NPPV'] as const;
export const INFUSION_OPTIONS = ['末梢', 'CV', 'ポート', 'PICC'] as const;
export const GASTROSTOMY_OPTIONS = ['バルーン', 'バンパー'] as const;

export type MedicalDevices = {
  oxygen?: string[];
  /** 酸素の使用量など（例: 2L） */
  oxygen_note?: string;
  insulin?: string;
  infusion?: string[];
  blood_glucose_per_day?: string;
  orthopedic_injection?: string;
  gastrostomy?: string;
  enterostomy?: string;
  tracheostomy_tube?: string;
  stoma?: string;
};

export const emptyMedicalDevices = (): MedicalDevices => ({});

export function isMedicalDevicesEmpty(d: MedicalDevices): boolean {
  if (d.oxygen && d.oxygen.length > 0) return false;
  if (d.infusion && d.infusion.length > 0) return false;
  if (d.gastrostomy) return false;
  const textKeys: (keyof MedicalDevices)[] = [
    'oxygen_note',
    'insulin',
    'blood_glucose_per_day',
    'orthopedic_injection',
    'enterostomy',
    'tracheostomy_tube',
    'stoma',
  ];
  return !textKeys.some((k) => {
    const v = d[k];
    return typeof v === 'string' && v.trim() !== '';
  });
}
